document.addEventListener('DOMContentLoaded', () => {

  /* ============================= */
  /* ABRIR MODAL                   */
  /* ============================= */

  document.querySelectorAll('.brand-card').forEach(card => {
    card.addEventListener('click', () => {
      const modal = document.getElementById(card.dataset.brandId);
      if (!modal) return;

      modal.classList.add('active');
      initCarousel(modal);
    });
  });

  /* ============================= */
  /* CARRUSEL (SCROLL CONTROLADO)  */
  /* ============================= */

  function initCarousel(modal) {
    const track = modal.querySelector('.brand-modal__products');
    const prev = modal.querySelector('.carousel-arrow.left');
    const next = modal.querySelector('.carousel-arrow.right');

    if (!track || !prev || !next) return;

    const cards = track.querySelectorAll('.brand-product-card');
    if (!cards.length) return;

    /* ⛔ evita registrar eventos múltiples */
    if (track.dataset.ready === '1') return;
    track.dataset.ready = '1';

    const getGap = () => {
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap);
      return isNaN(gap) ? 16 : gap;
    };

    const getStep = () => {
      return cards[0].getBoundingClientRect().width + getGap();
    };

    let index = 0;

    const maxIndex = () => {
      const visible = Math.floor(track.clientWidth / getStep());
      return Math.max(cards.length - visible, 0);
    };

    const goTo = (i) => {
      index = Math.max(0, Math.min(i, maxIndex()));
      track.scrollTo({
        left: index * getStep(),
        behavior: 'smooth'
      });
    };

    /* Reset al abrir modal */
    index = 0;
   track.scrollTo({ left: 1, behavior: 'auto' });

    /* Flecha derecha */
    next.onclick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      goTo(index + 1);
    };

    /* Flecha izquierda */
    prev.onclick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      goTo(index - 1);
    };

    /* Touch real en mobile */
    next.addEventListener('touchend', e => {
      e.preventDefault();
      e.stopPropagation();
      goTo(index + 1);
    }, { passive: false });

    prev.addEventListener('touchend', e => {
      e.preventDefault();
      e.stopPropagation();
      goTo(index - 1);
    }, { passive: false });
  }

  /* ============================= */
  /* CERRAR MODAL                  */
  /* ============================= */

  document.querySelectorAll('.brand-modal__close, .brand-modal__overlay')
    .forEach(el => {
      el.addEventListener('click', e => {
        const modal = e.target.closest('.brand-modal');
        if (modal) {
          modal.classList.remove('active');
          // resetea estado para próxima apertura
          modal.querySelectorAll('.brand-modal__products').forEach(t => {
            delete t.dataset.ready;
          });
        }
      });
    });

});
